import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import slider1 from '../assets/images/sliders/slider1.png';
import slider2 from '../assets/images/sliders/slider2.png';
import slider3 from '../assets/images/sliders/slider3.png';
import './CSS/HeroSlider.css';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: slider1,
      title: 'Fast & Reliable',
      titleHighlight: 'Device Repairs',
      subtitle: 'Phone and laptop repair services you can trust — quick turnarounds, expert hands.',
      primaryButton: 'Book a Repair',
      secondaryButton: 'Learn More'
    },
    {
      id: 2,
      image: slider2,
      title: 'Precision Services',
      titleHighlight: 'for What You Value',
      subtitle: 'From watch servicing to professional tennis stringing — we treat every detail with care.',
      primaryButton: 'Book a Repair',
      secondaryButton: 'Explore Services'
    },
    {
      id: 3,
      image: slider3,
      title: 'Coaching & Home',
      titleHighlight: 'Tech Support',
      subtitle: 'Need help with your computer or home setup? Our experts make it simple and stress-free.',
      primaryButton: 'Get Support Now',
      secondaryButton: 'Explore Services'
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1
      );
    }, 10000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${slide.image})`,
            }}
          >
            <div className="slide-overlay">
              <div className="container">
                <div className="slide-content">
                  <h1 className="hero-title">
                    {slide.title} <br />
                    <span className="text-primary">{slide.titleHighlight}</span>
                  </h1>
                  <p className="hero-subtitle">
                    {slide.subtitle}
                  </p>
                  <div className="hero-buttons">
                    <Link to="/contact" className="btn btn-primary">
                      {slide.primaryButton}
                    </Link>
                    <Link to="/about" className="btn btn-secondary">
                      {slide.secondaryButton}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Slide Indicators */}
      <div className="slide-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
